// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card.theme--dark[data-v-58fb2016],.v-card.theme--light[data-v-58fb2016]{background-color:#fff!important}.content[data-v-58fb2016]  h1{line-height:normal;margin-bottom:30px}.content[data-v-58fb2016]  h2{line-height:normal;margin-top:40px;margin-bottom:20px}.content[data-v-58fb2016]  h3{line-height:normal;margin-top:20px;margin-bottom:10px}.content[data-v-58fb2016]  p,.content[data-v-58fb2016]  ul{margin-top:10px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
